var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeamlesslyIntegrated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.4561,
    y: 30.8516,
    width: 24.6322,
    height: 24.1485,
    fill: "#256BE4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0882568,
    y: 30.5884,
    width: 24.6322,
    height: 24.1485,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0882568,
    width: 24.6322,
    height: 24.1485,
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlesslyIntegrated);
export default __webpack_public_path__ + "static/media/seamlessly-integrated.3d30b2c481dc8fd413a16c22b093d29b.svg";
export { ForwardRef as ReactComponent };